import React, { lazy, Suspense } from 'react';

const suspenseWrapper = children => {
  return typeof window !== 'undefined' ? <Suspense fallback={ null }>{ children }</Suspense> : null;
};
const CoverImage = lazy(() => import('../products/CoverImage'));
const CartList = lazy(() => import('../cart/CartList'));
const ProductList = lazy(() => import('../products/ProductList'));
const PlaceholderProductList = lazy(() => import('../products/PlaceholderProductList'));
const ProductDetail = lazy(() => import('../ProductDetail'));
const Fetching = lazy(() => import('../Fetching'));
const ErrorMessage = lazy(() => import('../ErrorMessage'));
const Carousel = lazy(() => import('@wsb/guac-widget-shared/lib/components/Carousel'));
const ClassicCarousel = lazy(() => import('../products/ProductDetailAssets/Classic'));
const FeaturedCarousel = lazy(() => import('../products/ProductDetailAssets/Featured'));

export {
  CoverImage,
  CartList,
  ProductList,
  PlaceholderProductList,
  ProductDetail,
  Fetching,
  ErrorMessage,
  Carousel,
  ClassicCarousel,
  FeaturedCarousel,
  suspenseWrapper
};
